/* eslint-disable import/no-anonymous-default-export */
import { API_CONFIG } from '../config/api.config';

/**
 * Servicio para gestionar el precio de leads
 */
class LeadPriceService {
  /**
   * Obtiene el precio de leads actual para un usuario específico
   * @param userId ID del usuario
   * @returns Precio de leads actual
   */
  async getLeadPrice(userId: string): Promise<number> {
    try {
      const token = localStorage.getItem('auth_token');

      // Usamos el endpoint general de usuario que incluye leadPrice
      const url = `${API_CONFIG.BASE_URL}api/users/${userId}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        }
        // Las peticiones GET no pueden tener body
      });


      if (!response.ok) {
        throw new Error(`Error al obtener precio de leads: ${response.status}`);
      }

      const data = await response.json();

      // Buscar el precio de leads en diferentes propiedades posibles
      let leadPrice = 0;
      if (data && typeof data === 'object') {
        if (data.leadPrice !== undefined) {
          leadPrice = data.leadPrice;
        } else if (data.price !== undefined) {
          leadPrice = data.price;
        } else if (data.data && data.data.leadPrice !== undefined) {
          leadPrice = data.data.leadPrice;
        } else if (data.user && data.user.leadPrice !== undefined) {
          leadPrice = data.user.leadPrice;
        }
      }

      // Si no encontramos el precio en ninguna parte, buscar en toda la estructura
      if (leadPrice === 0) {
        const findLeadPrice = (obj: any): number => {
          if (!obj || typeof obj !== 'object') return 0;

          if (obj.leadPrice !== undefined) return obj.leadPrice;

          for (const key in obj) {
            if (typeof obj[key] === 'object') {
              const found = findLeadPrice(obj[key]);
              if (found !== 0) return found;
            }
          }

          return 0;
        };

        leadPrice = findLeadPrice(data);
      }

      return leadPrice;
    } catch (error) {
      return 0;
    }
  }

  /**
   * Actualiza el precio de leads para un usuario específico
   * @param userId ID del usuario
   * @param leadPrice Nuevo precio de leads
   * @returns Respuesta de la API
   */
  async updateLeadPrice(userId: string, leadPrice: number): Promise<any> {
    try {

      const token = localStorage.getItem('auth_token');

      const url = `${API_CONFIG.BASE_URL}api/users/${userId}/lead-price`;

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        body: JSON.stringify({ leadPrice })
      });

      if (!response.ok) {
        throw new Error(`Error al actualizar precio de leads: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
}

//export default new LeadPriceService();
const leadPriceService = new LeadPriceService();
export default leadPriceService;
